import React from 'react';
interface SectionHeadingProps {
  title: string;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
}
export function SectionHeading({
  title,
  description,
  align = 'center',
  tone = 'light'
}: SectionHeadingProps) {
  return <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-270" data-mp="3f3ggl6sh1wcu">
      <h2 className={`font-display text-3xl leading-tight md:text-[42px] ${tone === 'light' ? 'text-forest-900' : 'text-white'}`} data-id="element-271" data-mp="3k29kc7hyi8zt">
        {title}
      </h2>
      <span className={`mt-4 block h-px w-16 bg-gold ${align === 'center' ? 'mx-auto' : ''}`} aria-hidden="true" data-id="element-272" data-mp="giomhg1178uo" />
      {description && <p className={`mt-5 text-[15px] leading-relaxed ${tone === 'light' ? 'text-forest-900/70' : 'text-white/75'}`} data-id="element-273" data-mp="6slm2urkysmb">
          {description}
        </p>}
    </div>;
}